import moment from "moment";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export interface MembershipCardProps {
  id: string;
  name: string;
  description: string;
  created_at: string;
  expires_at: string;
  validity: string;
  membership_number: string;
  subscription_type: string;
  entity_id: string;
}

export default function Component({
  userSubscription,
}: {
  userSubscription: MembershipCardProps[];
}) {
  const [isCourse, setIsCourse] = useState(false);
  const [isYearly, setIsYearly] = useState(false);
  useEffect(() => {
    if (userSubscription[0].subscription_type === "course") {
      setIsCourse(true);
    }
    if (userSubscription[0].validity === "yearly") {
      setIsYearly(true);
    }
  }, [userSubscription]);
  return (
    <div>
      {userSubscription.length === 1 ? (
        <div className="flex justify-between w-full overflow-x-scroll">
          <div
            className="relative !w-[361px] h-[264px] rounded-[10px] border border-[#404040] overflow-hidden"
            style={{
              background:
                "linear-gradient(236deg, #3F3F3F 0.91%, #090909 76.42%)",
            }}
          >
            {/* Wavy pattern background */}
            <div className="absolute inset-0 opacity-80">
              <img
                src="/assets/membership/looper.png"
                alt="Wavy Animation"
                className="w-full h-full"
              />
            </div>

            {/* Card content */}
            <div className="!w-[361px] h-[264px] relative z-10 h-full flex flex-col justify-between p-6">
              <div>
                <div className="flex justify-between">
                  <div className="flex flex-col">
                    <div className="flex gap-1">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#4ADE80] mt-1" />
                      <span className="text-[#4ADE80] text-[10px] font-medium tracking-wide">
                        ACTIVE
                      </span>
                    </div>
                    <div className="space-y-1">
                      <h2 className="text-[28px] font-bold leading-tight text-white">
                        1% Club
                      </h2>
                    </div>
                  </div>
                  {!isCourse ? (
                    <div className="text-right text-[#CDCDCD] text-lg font-bold bg-gradient-text text-transparent bg-clip-text w-[120px]">
                      {isYearly ? "Lifetime Access" : "Yearly Membership"}
                    </div>
                  ) : (
                    <div className="text-right text-[#CDCDCD] text-lg font-bold w-[80px]">
                      {userSubscription[0].name}
                    </div>
                  )}
                </div>

                <div className="flex justify-between items-start"></div>
              </div>
              {isYearly ? (
                <div className="text-white">
                  <h2 className="text-[#999999] text-[15px] font-[SF_Pro]">
                    Ends On{" "}
                    {moment(userSubscription[0].expires_at).format("DD/MM/YY")}
                  </h2>
                  <div className="flex justify-between items-center mt-2">
                    <div className="w-full bg-gray-700 rounded-lg h-3">
                      <div
                        className="bg-gradient-text h-3 rounded-lg"
                        style={{
                          width:
                            `${(moment(userSubscription[0].expires_at).diff(moment(), "days") / 366) * 100}%` ||
                            0,
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-white w-full font-[SF_Pro]">
                  {/* <h2 className="text-white font-[SF_Pro] tracking-widest font-semibold">
                                SH-20241022-001
                            </h2> */}
                  <div className="w-full flex justify-between text-[#BDBDBD] text-[10px]">
                    <h1>MEMBER SINCE</h1>
                    <h1>INVITED BY</h1>
                  </div>
                  <div className="w-full flex justify-between text-white text-[13px]">
                    <h1>
                      {moment(userSubscription[0].created_at).format(
                        "DD MMM YYYY",
                      )}
                    </h1>
                    <h1>Sharan Hegde</h1>
                  </div>
                </div>
              )}
            </div>
          </div>
          {isCourse && <UnlockBenefits isWide={false} />}
        </div>
      ) : (
        <>
          <div className="flex justify-evenly w-full overflow-x-scroll">
            {userSubscription.map((subscription) => (
              <div
                className="relative w-[361px] h-[264px] rounded-[10px] border border-[#404040] overflow-hidden"
                style={{
                  background:
                    "linear-gradient(236deg, #3F3F3F 0.91%, #090909 76.42%)",
                }}
              >
                {/* Wavy pattern background */}
                <div className="absolute inset-0 opacity-80">
                  <img
                    src="/assets/membership/looper.png"
                    alt="Wavy Animation"
                    className="w-full h-full"
                  />
                </div>

                {/* Card content */}
                <div className="relative z-10 h-full flex flex-col justify-between p-6">
                  <div>
                    <div className="flex justify-between">
                      <div className="flex flex-col">
                        <div className="flex gap-1">
                          <div className="w-1.5 h-1.5 rounded-full bg-[#4ADE80] mt-1" />
                          <span className="text-[#4ADE80] text-[10px] font-medium tracking-wide">
                            ACTIVE
                          </span>
                        </div>
                        <div className="space-y-1">
                          <h2 className="text-[28px] font-bold leading-tight text-white">
                            1% Club
                          </h2>
                        </div>
                      </div>
                      <div className="text-right text-[#CDCDCD] text-lg font-bold text-white w-[130px] pr-2">
                        {subscription.description}
                      </div>
                    </div>

                    <div className="flex justify-between items-start"></div>
                  </div>
                  <div className="text-white">
                    <h2 className="text-[#999999] text-[15px] font-[SF_Pro]">
                      Ends On{" "}
                      {moment(subscription.expires_at).format("DD/MM/YY")}
                    </h2>
                    <div className="flex justify-between items-center mt-2">
                      <div className="w-full bg-gray-700 rounded-lg h-3">
                        <div
                          className="bg-gradient-text h-3 rounded-lg"
                          style={{
                            width:
                              `${(moment(subscription.expires_at).diff(moment(), "days") / 366) * 100}%` ||
                              0,
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <UnlockBenefits isWide={true} />
        </>
      )}
    </div>
  );
}

const UnlockBenefits = ({ isWide }: { isWide?: boolean }) => {
  return (
    <Link
      to={
        "https://dev.payment.onepercentclub.io/memberships/673c19622c49f349c1a7cf16"
      }
    >
      <div className={`${isWide ? "w-full mt-6" : "w-[361px]"}`}>
        <img
          src={
            isWide
              ? "/assets/membership/unlock-member-card-wide.png"
              : "/assets/membership/unlock-member-card.png"
          }
          alt="Wavy Animation"
          className="w-full h-full"
        />
      </div>
    </Link>
  );
};
